export default class DesactivarSubcategoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idSubcategoria) {
    try {
      const result = await this.#repository.desactivarSubcategoria(idSubcategoria)
      return result
    } catch (error) {
      throw error
    }
  }
}
